module.exports = __webpack_public_path__ + "img/food6.955953b7.png";